<template>
  <div style="text-align: center">
    <div>
      <h2 class="mb-4">This shop is empty</h2>
    </div>
    <div>
      <img
        src="../../../assets/images/empty_bag.svg"
        width="150"
        class="mb4 mt-4"
      />
    </div>
    <div style="margin-top: 40px">
      <p>
        There are no products currently for sale.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>
